/**
 * Coordinates live/HTTP overview refreshes without letting an earlier account's
 * response replace the most recent state. Abort is advisory: request identity
 * is checked even when a transport ignores AbortSignal.
 *
 * No credentials or data are retained after cancellation.
 */
export function createGeoOverviewCoordinator({read,onBegin=()=>{},onSuccess=()=>{},onError=()=>{},onEnd=()=>{}}){
  if(typeof read!=='function')throw new TypeError('A Geo overview read function is required.');
  let active=null;
  const cancel=()=>{const previous=active;active=null;previous?.abort();};
  const refresh=async()=>{
    cancel();
    const request=new AbortController();
    active=request;
    onBegin();
    try{
      const result=await read(request.signal);
      if(active===request&&!request.signal.aborted)onSuccess(result);
    }catch(error){
      if(active===request&&!request.signal.aborted&&error?.code!=='ERR_CANCELED'&&error?.name!=='AbortError')onError(error);
    }finally{
      if(active===request){active=null;onEnd();}
    }
  };
  return {refresh,cancel};
}
